let inject = [
    '$scope',
    'ReportOrdersService',
    '$state',
    '$rootScope',
    'SharedService',
    '$timeout',
    'ngAuthSettings',
    'CartService',
    'SessionService',
    'NgTableParams',
    '$uibModal',
    '$filter'
];

class ReportOrdersController {
    constructor($scope,
                ReportOrdersService,
                $state,
                $rootScope,
                SharedService,
                $timeout,
                ngAuthSettings,
                CartService,
                SessionService,
                NgTableParams,
                $uibModal,
                $filter) {
        this.$state = $state;
        this.SessionService = SessionService;
        this.ngAuthSettings = ngAuthSettings;
        this.CartService = CartService;
        this.$filter = $filter;
        // this.$scope = $scope;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.NgTableParams = NgTableParams;
        this.ReportOrdersService = ReportOrdersService;
        this.$uibModal = $uibModal;
        this.SharedService = SharedService;

        this.orders = null;
        this.ordersExcel = null;
        this.state = {};
        this.branches = [];

        this.stateOrder = {};
        this.orderSelected = null;
        this.orderSelectedBase = null;
        this.orderVrNetoTotal = 0;
        this.orderVrNetoPendiente = 0;
        this.watchingOrder = false;

        // ngTable Params
        this.ngTableConfigOrder = null;
        this.ngTableColsOrder = null;

        this.totalValueToPayOrders = 0;
        this.totalValuePendingOrders = 0;
        this.updatedAt = '';

        // ngTable Params
        this.ngTableConfig = null;
        this.ngTableCols = null;
        this.thirdSelected = null;
        this.branchesSelected = null;

        this.exportingData = false;
        this.exportCorrect = false;


        this.sort = null;
        this.searchText = '';
        this.sortType = 'pedido_id';
        this.sortOrientation = 'DESC';
        this.sortReverse = true;
        this.userOrders = [];
        this.summary = [];
        this.itemsPerPage = 12;
        this.loadingUserOrders = true;
        this.loadedUserOrders = false;
        this.errorloadingUserOrders = false;
        this.currentPage = 1;
        this.actualPage = 0;
        this.filters = {};
        this.filtersCopy = {};


        this.maxSize = 5;
        this.bigTotalItems = 0;
        this.bigCurrentPage = 1;
        this.totalItemsPage = 12;
        this.statictics = {};

        this.bigTotalItemsDetails = 0;
        this.bigCurrentPageDetail = 1;
        this.totalItemsPageDetail = 12;


        this.count = 0;
        this.numberDaysReport = null;
    }

    $onInit() {
        if (!this.shCtrl.globals.currentClient) this.shCtrl.globals.currentClient = {};
        if (!this.shCtrl.globals.currentClient.third) return;
        if (!this.shCtrl.globals.currentClient.third.documentNumber) return;
        let paginar = __env.adaptative === true;
        this.getOrderStates(false, paginar);
    }

    getBranches(item) {
        this.ReportOrdersService.getBranchesByThirdId(item.id).then(response => {
            this.branches = response;
        }); 
    }

    getOrderStates(manual, paginar = true, orderRequest = false, orderObject = null, paginationInicial, paginationFinal) {

        this.sort = manual;

        let documentNumber = '';
        let branchCode = '';

        let limit = this.totalItemsPage;
        let page = this.bigCurrentPage;

        if (!paginar) {
            limit = "";
            page = "";
        }else{
            if (paginationInicial==undefined && paginationFinal==undefined) {
                paginationInicial   =   0;
                paginationFinal     =   limit;
            }
        }

        try {
            if (manual) {
                console.log("enetering in manual", manual);
                this.orders = [];
                this.ordersExcel = [];
                documentNumber = this.thirdSelected.nit;
                if (angular.isArray(this.branchesSelected)) {
                    branchCode = this.branchesSelected;
                } else if (this.branchesSelected) {
                    branchCode = [this.branchesSelected.id];
                } else {
                    branchCode = [];
                }

            } else {
                documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
                branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
            }
        }
        catch (e) {
            return;
        }

        if (!documentNumber || !branchCode) {
            alert('Para realizar la consulta se necesita el numero de documento y el codigo de la sucursal.');
        }

        else {
            this.state = {};
            this.state.loading = true;
            if (manual) {
                this.ReportOrdersService.getOrderStatesBranches(documentNumber, branchCode, this.fecha_ini, this.fecha_fin, limit, page).then(orders => {
                    this.state.loading = false;
                    this.state.loaded = true;

                    this.orders = orders.data;
                    this.ordersExcel = orders.data;

                    this.totalValueToPayOrders = 0;
                    this.totalValuePendingOrders = 0;
                    this.numberDaysReport = orders.numberDays;

                    angular.forEach(orders.data, (order) => {
                        let valor_pagar = +order.valor_pagar;
                        let valor_pendiente = +order.valor_pendiente;

                        this.totalValueToPayOrders = this.totalValueToPayOrders + valor_pagar;
                        this.totalValuePendingOrders = this.totalValuePendingOrders + valor_pendiente;
                    });

                    this.bigTotalItems = this.orders.total;

                    this.initNgTable();

                    this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                }).catch(error => {
                    this.state.loading = false;
                    this.state.error = true;
                });
            } else {
                this.ReportOrdersService.getOrderStates(documentNumber, branchCode, limit, page, orderRequest && orderObject.orderColumn.length > 0 ? orderObject : null)
                    .then(orders => {
                        this.state.loading = false;
                        this.state.loaded = true;
                        //console.log("page: "+paginationInicial);
                        //console.log("limit: "+paginationFinal);
                        this.orders = orders.data.slice(paginationInicial,paginationFinal);
                        this.ordersExcel = orders.data;
                        this.numberDaysReport = orders.numberDays;
                        if(!paginar){
                            this.totalValueToPayOrders = 0;
                            this.totalValuePendingOrders = 0;

                            angular.forEach(orders.data, order => {
                                let valor_pagar = +order.valor_pagar;
                                let valor_pendiente = +order.valor_pendiente;

                                this.totalValueToPayOrders = this.totalValueToPayOrders + valor_pagar;
                                this.totalValuePendingOrders = this.totalValuePendingOrders + valor_pendiente;
                            });
                        }else{
                            this.totalValueToPayOrders = orders.totalValorPagar;
                            this.totalValuePendingOrders = orders.totalValorPendiente;
                        }

                        this.bigTotalItems = orders.total;

                        this.initNgTable();

                        this.updatedAt = this.$filter('date')(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    })
                    .catch((error) => {
                        this.state.loading = false;
                        this.state.error = true;
                    });
            }
        }
    }

    selectOrder(orderSelected, paginar = false,paginationInicial,paginationFinal) {
        this.watchingOrder = true;
        this.stateOrder.loading = true;
        this.orderSelectedBase = orderSelected;
        let documentNumber = '';
        let branchCode = '';
        let nit = '';

        let limit = this.totalItemsPageDetail;
        let page = this.bigCurrentPageDetail;

        if (!paginar) {
            limit = "";
            page = "";
        }else{
            if (paginationInicial==undefined && paginationFinal==undefined) {
                paginationInicial   =   0;
                paginationFinal     =   limit;
            }
        }

        try {
            nit = this.thirdSelected.nit;
        } catch (e) {
        }
        if (nit) {
            documentNumber = this.thirdSelected.nit;
            if (angular.isArray(this.branchesSelected)) {
                branchCode = this.branchesSelected;
            } else if (this.branchesSelected) {
                branchCode = [this.branchesSelected.id];
            } else {
                branchCode = [];
            }

        } else {
            documentNumber = this.shCtrl.globals.currentClient.third.documentNumber;
            branchCode = this.shCtrl.globals.currentClient.operatingCenter.code;
        }

        this.ReportOrdersService.getOrderState(documentNumber, branchCode, orderSelected.pedido_id, limit, page, orderSelected.orden_compra)
            .then((order) => {
                this.stateOrder.loading = false;
                this.stateOrder.loaded = true;
                //console.log("limit: "+paginationFinal);
                this.orderSelected = order.data.slice(paginationInicial,paginationFinal);
                
                this.bigTotalItemsDetails = order.total;
                this.orderVrNetoTotal = orderSelected.valor_pagar;
                this.orderVrNetoPendiente = orderSelected.valor_pendiente;
                

                this.initNgTableOrder();
            }).catch((error) => {
            this.stateOrder.loading = false;
            this.stateOrder.loaded = true;
            this.stateOrder.error = true;
        });
    }

    blurOrder() {
        this.orderSelected = null;
        this.watchingOrder = false;
    }

    initNgTableOrder() {
        /**
         * destino:                             "ORDEN DE COMPRA 30455 **23183** LO RECOGEN"
         * fecha_pedido:                  (OK)  "2016-07-18 00:00:00"
         * id:                                  248
         * item_cantidad_despachada:      (OK)  0
         * item_cantidad_pedida:          (OK)  4
         * item_centro_operacion_pedido:        1
         * item_descripcion:              (OK)  "TRIAGE CARDIAC PANEL X 25 PBS"
         * item_estado:                   (OK)  null
         * item_fecha_entrega:            (OK)  "2016-07-18 00:00:00"(OK)
         * item_referencia:               (OK)  "97000HSEU"
         * item_unidad_medida:            (OK)  "UND"
         * item_valor_descuento:          (OK)  0
         * item_valor_total:              (OK)  1800000
         * item_valor_unitario:           (OK)  450000
         * pedido_estado:                       "1"
         * pedido_id:                           "PV-150296"
         * sucursal:                            "ANGEL DIAGNOSTICA S A/CAMBULOS"
         * sucursal_id:                         "01"
         * tercero:                             "ANGEL DIAGNOSTICA S A"
         * tercero_id:                          "805013591"
         * valor_pagar:                         null
         * valor_pendiente:                     null
         * vendedor:                            "ALVAREZ ACHURY CONSTANZA VIVIANA"
         * vendedor_id:                         "0231"
         */

        this.ngTableColsOrder = [
            {
                field: "fecha_pedido",
                title: "Fecha Pedido",
                sortable: "fecha_pedido",
                filter: {"fecha_pedido": "text"},
                show: true
            },
            {
                field: "item_fecha_entrega",
                title: "Entrega",
                sortable: "item_fecha_entrega",
                filter: {"item_fecha_entrega": "text"},
                show: true
            },
            {
                field: "item_referencia",
                title: "Ref.",
                sortable: "item_referencia",
                filter: {"item_referencia": "text"},
                show: true
            },
            {
                field: "item_descripcion",
                title: "Descripción",
                sortable: "item_descripcion",
                filter: {"item_descripcion": "text"},
                show: true
            },
            {
                field: "item_estado",
                title: "Estado ítem",
                sortable: "item_estado",
                filter: {"item_estado": "text"},
                show: true
            },
            {
                field: "item_unidad_medida",
                title: "U.M.",
                sortable: "item_unidad_medida",
                filter: {"item_unidad_medida": "text"},
                show: true
            },
            {
                field: "item_cantidad_pedida",
                title: "Cant. Pedida",
                sortable: "item_cantidad_pedida",
                filter: {"item_cantidad_pedida": "number"},
                show: true
            },
            // {
            //   field: "item_cantidad_despachada",
            //   title: "Cant. Despachada",
            //   sortable: "item_cantidad_despachada",
            //   filter: { "item_cantidad_despachada": "text" },
            //   show: true
            // },
            // {
            //   field: "item_cantidad_pendiente",
            //   title: "Cant. Pendiente",
            //   sortable: "item_cantidad_pendiente",
            //   filter: { "item_cantidad_pendiente": "text" },
            //   show: true
            // },
            {
                field: "item_valor_unitario",
                title: "Vr. Unit.",
                sortable: "item_valor_unitario",
                filter: {"item_valor_unitario": "number"},
                show: true
            },
            {
                field: "item_valor_impuesto",
                title: "VR IMPUESTOS",
                sortable: "item_valor_impuesto",
                filter: {"item_valor_impuesto": "number"},
                show: true
            },
            {
                field: "item_valor_descuento",
                title: "Vr. Desc.",
                sortable: "item_valor_descuento",
                filter: {"item_valor_descuento": "number"},
                show: true
            },
            {
                field: "item_valor_total",
                title: "Vr. Neto",
                sortable: "item_valor_total",
                filter: {"item_valor_total": "number"},
                show: true
            }
        ];

        let initialParams = {
            count: 20,
            sorting: {fecha_pedido: "desc"}
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.orderSelected
        };

        this.ngTableConfigOrder = new this.NgTableParams(initialParams, initialSettings);
    }

    initNgTable() {

        this.ngTableCols = [
            {
                field: "pedido_id",
                title: "Pedido",
                sortable: "pedido_id",
                filter: {"pedido_id": "text"},
                show: true
            },
            {
                field: "co_nombre",
                title: "Centro operacion",
                sortable: "co_nombre",
                filter: {"co_nombre": "text"},
                show: true
            },
            {
                field: "orden_compra",
                title: "Orden de compra",
                sortable: "orden_compra",
                filter: {"orden_compra": "text"},
                show: true
            },
            {
                field: "pedido_estado",
                title: "Estado",
                sortable: "pedido_estado",
                filter: {"pedido_estado": "text"},
                show: true
            },
            {
                field: "fecha_pedido",
                title: "Fecha del Pedido",
                sortable: "fecha_pedido",
                filter: {"fecha_pedido": "text"},
                show: true
            },
            {
                field: "fecha_actualizacion",
                title: "Fecha Ultima Actualización",
                sortable: "fecha_actualizacion",
                filter: {"fecha_actualizacion": "text"},
                show: false
            },
            {
                field: "sucursal",
                title: "Punto de Envío",
                sortable: "sucursal",
                filter: {"sucursal": "text"},
                show: true
            },
            {
                field: "vendedor",
                title: "Vendedor",
                sortable: "vendedor",
                filter: {"vendedor": "text"},
                show: true
            },
            {
                field: "valor_pagar",
                title: "Vr. Neto Total",
                sortable: "valor_pagar",
                filter: {"valor_pagar": "number"},
                show: true
            },
            {
                field: "valor_pendiente",
                title: "Vr. Neto Pendiente",
                sortable: "valor_pendiente",
                filter: {"valor_pendiente": "number"},
                show: true
            },
            {
                field: "actions",
                title: "Detalle",
                show: true
            },
        ];

        let initialParams = {
            count: 20,
            sorting: {fecha_pedido: "desc"}
        };

        let initialSettings = {
            counts: [5, 10, 20],
            paginationMaxBlocks: 8,
            paginationMinBlocks: 2,
            dataset: this.orders
        };

        this.ngTableConfig = new this.NgTableParams(initialParams, initialSettings);
    }

    exportExcel() {
        this.exportingData = true;
        //console.log(this.orders);
        let nameClient = this.shCtrl.globals.currentClient.third.name;
        this.ReportOrdersService.getExportExcel(this.ordersExcel, nameClient)
            .then((datos) => {
                console.log(datos.data.url_excel);
                open(datos.data.url_excel, '_blank');
                this.exportingData = false;
                this.exportCorrect = true;

            }).catch((error) => {
            this.exportingData = false;
            this.exportCorrect = false;

        });


    }


    showSort(value) {
        this.sort = value;
    }

}

ReportOrdersController.$inject = inject;

export default ReportOrdersController;




/** WEBPACK FOOTER **
 ** ./www/components/reports/orders/orders.controller.js
 **/